import { useEffect, useState } from "react";
import bg from "../../assets/images/png/gift-bg-img.png";
const Reward = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    const updateCountdown = () => {
      const difference = +new Date("2025-04-30T00:00:00") - +new Date();

      if (difference > 0) {
        setTimeLeft({
          hours: String(
            Math.floor((difference / (1000 * 60 * 60)) % 24)
          ).padStart(2, "0"),
          minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(
            2,
            "0"
          ),
          seconds: String(Math.floor((difference / 1000) % 60)).padStart(
            2,
            "0"
          ),
        });
      }
    };

    updateCountdown(); // Run once on mount
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <div
        style={{ background: `url(${bg})` }}
        className="flex items-center min-h-screen relative bg-cover bg-no-repeat bg-center">
        <div className="max-w-[1140px] max-md:!px-4 ps-10 max-md:ps-0">
          <h1 className="text-6xl font-medium text-[#1b1464] max-md:text-4xl max-sm:text-3xl">
            Coming Soon <br /> Launching On
            <span className="font-bold text-[70px] max-md:text-4xl">
              {" "}
              30 April
            </span>
          </h1>
          <p className="my-4">
            <a
              href="/"
              className="text-4xl font-bold max-md:text-2xl text-black">
              shop.makewayindia.com
            </a>
          </p>
          <div className="bg-[#1b1464] text-white rounded-xl px-6 py-4 mt-10 inline-flex gap-6 text-center text-lg">
            <div>
              <div className="text-3xl font-bold">{timeLeft.hours}</div>
              <div className="text-sm">HOURS</div>
            </div>
            <div>
              <div className="text-3xl font-bold">{timeLeft.minutes}</div>
              <div className="text-sm">MINUTES</div>
            </div>
            <div>
              <div className="text-3xl font-bold">{timeLeft.seconds}</div>
              <div className="text-sm">SECONDS</div>
            </div>
          </div>
          <div className="mt-6">
            <button className="bg-[#1b1464] ease-linear duration-300 hover:bg-[#120d45] cursor-pointer text-white font-medium py-2 px-6 rounded-lg transition">
              Find the Perfect Gift
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reward;
